import { render, staticRenderFns } from "./FavoritingToggle.vue?vue&type=template&id=49d7c106&"
import script from "./FavoritingToggle.vue?vue&type=script&lang=js&"
export * from "./FavoritingToggle.vue?vue&type=script&lang=js&"
import style0 from "./FavoritingToggle.vue?vue&type=style&index=0&id=49d7c106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports